import {
  Box,
  Button,
  Card,
  CardBody,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiCheckCircle } from 'react-icons/fi'

const settings = [
  {
    title: 'Выделение выходных',
    description:
      'Подсвечивает субботу и воскресенье в графике. Помогает быстро считывать рабочие и нерабочие дни.',
  },
  {
    title: 'Максимальная длина блока (дней)',
    description:
      'Ограничивает длину одной задачи, чтобы случайно не создать чрезмерно длинный блок.',
  },
  {
    title: 'Дней в прошлом для загрузки таблицы',
    description: 'Определяет, сколько прошедших дней видно в режиме редактирования графика.',
  },
  {
    title: 'Дней в прошлом для таблицы просмотра',
    description: 'Отдельная глубина истории для режима просмотра без редактирования.',
  },
  {
    title: 'Учитывать время при планировании',
    description:
      'Переключает график в формат по часам и использует рабочее время (например 08:00–18:00).',
  },
]

export const SettingsPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={7}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.600" mb={3}>
            ⚙️ Настройки и отчёты
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Здесь задаются рабочие правила для всей команды: как отображается график
            и как формируются данные для ежедневной работы.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          {settings.map((item, idx) => (
            <Card key={item.title}>
              <CardBody>
                <Text fontSize="sm" fontWeight="700" color="brand.600" mb={2}>
                  Настройка {idx + 1}
                </Text>
                <Heading size="sm" mb={2}>
                  {item.title}
                </Heading>
                <Text color="gray.600">{item.description}</Text>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>

        <Card>
          <CardBody>
            <Heading size="sm" mb={3}>Как менять настройки без ошибок</Heading>
            <List spacing={2}>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Изменяйте по одному параметру за раз.</ListItem>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />После сохранения сразу откройте «График работ» и проверьте результат.</ListItem>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Если результат не подходит — верните предыдущее значение.</ListItem>
            </List>
          </CardBody>
        </Card>

        <Box>
          <Heading size="md" mb={3}>Связанные разделы</Heading>
          <Button as={RouterLink} to="/schedule" mr={3} variant="outline">График работ</Button>
          <Button as={RouterLink} to="/warehouse" mr={3} variant="outline">Склад</Button>
          <Button as={RouterLink} to="/troubleshooting" variant="outline">Частые вопросы</Button>
        </Box>
      </VStack>
    </Container>
  )
}
